import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import authHOC from '../Components/AuthHOC';
import LoginView from './Components/LoginView';

import { authAdminRequest, authUserRequest, getTokenFromCookies, loginReset } from '../redux/reducers/login';
import { API_DONT_SHOW_TUTORIAL_SUCCESS } from '../redux/reducers/tutorial';

import { resetDeactivate } from '../redux/reducers/deactivate';
import Notification from '../Components/Popups/Notification';

import {
  getUserProgramsFullRequest, toggleSplashView,
} from '../redux/reducers/userProgramsFull';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Login = ({
  isShowLogin,
  showRegistrationPopup,
  showForgottenPopup,
  handlePopupToggle,
  handleForgottenPopup,
  handleRegistrationPopup,
  isDeactivated
}) => (
  <div>
  <LoginView
    isShowLogin={isShowLogin}
    showRegistrationPopup={showRegistrationPopup}
    showForgottenPopup={showForgottenPopup}
    handlePopupToggle={handlePopupToggle}
    handleForgottenPopup={handleForgottenPopup}
    handleRegistrationPopup={handleRegistrationPopup}
    isDeactivated={isDeactivated}
  />
  </div>

);

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  isDeactivated: state.DeactivateReducer.isDeactivated,
  userProgramsFull: state.userProgramsFullReducer,
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: () => dispatch(authAdminRequest()),
  loginReset: () => dispatch(loginReset()),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  toggleSplashView: bool => dispatch(toggleSplashView(bool)),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  withState('isShowLogin', 'toggleLogin', true),
  withState('showForgottenPopup', 'toggleForgottenPopup', false),
  withState('showRegistrationPopup', 'toggleRegistrationPopup', false),
  withState('resetSuccessMessageDone', 'handleResetSuccessMessage', false),
  withHandlers({
    handlePopupToggle: props => event => {
      event.preventDefault();
      props.toggleForgottenPopup(false);
      props.toggleRegistrationPopup(false);
      props.toggleLogin(!props.isShowLogin);
    },
    handleForgottenPopup: props => event => {
      event.preventDefault();
      props.toggleLogin(!props.isShowLogin);
      props.toggleForgottenPopup(!props.showForgottenPopup);
    },
    handleRegistrationPopup: props => event => {
      event.preventDefault();
      props.toggleLogin(false);
      props.toggleForgottenPopup(false);
      props.toggleRegistrationPopup(true);
    },
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      
      const { history, loginReducer } = this.props;
      if (loginReducer.isLoggedIn && !loginReducer.error) {
        history.push('/home' + history.location.search);
      }else{
       
      }
    },
    componentWillReceiveProps(nextProps) {
      const { history, loginReducer } = nextProps;
      
      if (loginReducer.isLoggedIn && !loginReducer.error) {
        
          history.push('/home' + history.location.search);
      }
    },
    componentWillUnmount() {
      clearTimeout(this.props.timer);
    },
  }),
)(Login);

Login.propTypes = {
  showForgottenPopup: PropTypes.bool,
  showRegistrationPopup: PropTypes.bool,
  isShowLogin: PropTypes.bool,
  handlePopupToggle: PropTypes.func,
  handleForgottenPopup: PropTypes.func,
  handleRegistrationPopup: PropTypes.func,
};
